import { useEffect } from 'react';

const useDisableBodyScrollSwipe = (): void => {
  // Fix horizontal scrolling issues
  useEffect(() => {
    document.getElementsByTagName('html')[0].style.overflowX = 'hidden';
    document.getElementsByTagName('html')[0].style.overscrollBehaviorX = 'none';
    document.body.style.overflowX = 'hidden';
    document.body.style.overscrollBehaviorX = 'none';

    return () => {
      document.getElementsByTagName('html')[0].style.overflowX = '';
      document.getElementsByTagName('html')[0].style.overscrollBehaviorX = '';
      document.body.style.overflowX = '';
      document.body.style.overscrollBehaviorX = '';
    };
  }, []);
};

export default useDisableBodyScrollSwipe;
